import { shallowMount } from "@vue/test-utils";
import RenaperConfirmar from "@/views/RenaperConfirmar";

describe("RenaperConfirmar component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(RenaperConfirmar);
  });

  it("Renders del component RenaperConfirmar", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
